// Общие значения режима закрывающих документов для компонентов обоих кабинетов.
export const ServiceApplicationClosingDocumentsMode = {
	SeparateDocuments: "SeparateDocuments",
	Utd: "Utd"
} as const;

export type ServiceApplicationClosingDocumentsMode =
	typeof ServiceApplicationClosingDocumentsMode[keyof typeof ServiceApplicationClosingDocumentsMode];
